<template>
  <div id="tags-view-container" class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.path"
        :class="isActive(tag) ? 'active' : ''"
        :to="{
          name: tag.name,
          path: tag.path,
          query: tag.query,
          params: tag.params,
          fullPath: tag.fullPath,
        }"
        tag="span"
        class="tags-view-item"
        @click.middle.native="closeSelectedTag(tag)"
        @contextmenu.prevent.native="openMenu(tag, $event)"
      >
        {{ getTagTitle(tag) }}
        <span v-if="!tag.meta.affix" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{ left: left + 'px', top: 32 + 'px' }" class="contextmenu">
      <!-- <li @click="refreshSelectedTag(selectedTag)">刷新</li> -->
      <li v-if="!(selectedTag.meta && selectedTag.meta.affix)" @click="closeSelectedTag(selectedTag)">关闭本页面</li>
      <li @click="closeOthersTags" v-if="visitedViews.length > 1">关闭其他页面</li>
      <li @click="closeAllTags(selectedTag)">关闭所有页面</li>
    </ul>
  </div>
</template>

<script>
import { useTag } from '@/composables';
import ScrollPane from './ScrollPane.vue';

export default {
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      routes: [],
      visitedViews: [],
      activeTags: [],
    };
  },
  computed: {},
  watch: {
    $route() {
      this.addTags();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu);
      } else {
        document.body.removeEventListener('click', this.closeMenu);
      }
    },
  },

  methods: {
    getTagTitle(tag) {
      const activeTag = this.activeTags.find((item) => item.path === tag.path) || {};
      if (tag.meta) {
        return activeTag.meta?.title || tag.meta.title;
      }
      return activeTag.meta?.title || tag.title;
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
    addTags() {
      const { name, path } = this.$route;
      if (!name) {
        return;
      }
      if (this.visitedViews.some((item) => item.path === path)) {
        return;
      }
      this.visitedViews.push(this.$route);
    },

    refreshSelectedTag(view) {
      console.log(view);
    },
    closeSelectedTag(view) {
      const index = this.visitedViews.findIndex((item) => item.path === view.path);
      this.visitedViews.splice(index, 1);
      if (this.isActive(view)) {
        this.toLastView(this.visitedViews, view);
      }
    },
    closeOthersTags() {
      if (this.isActive(this.selectedTag)) {
        this.visitedViews = [this.selectedTag];
      } else {
        this.visitedViews = [];
        this.$router.push(this.selectedTag);
      }
    },
    closeAllTags(view) {
      this.toLastView([], view);
      const length = this.visitedViews.length;
      this.$nextTick(() => {
        this.visitedViews.splice(0, length);
      });
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'console.home') {
          // to reload home page
          //   this.$router.replace({ path: '/redirect' + view.fullPath })
          this.$router.replace({ path: view.fullPath });
        } else {
          this.$router.push('/');
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const left = e.clientX - offsetLeft + 15; // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }

      this.top = e.clientY;
      this.visible = true;
      this.selectedTag = tag;
    },
    closeMenu() {
      this.visible = false;
    },
  },
  created() {},
  mounted() {
    // this.initTags();
    this.addTags();
    useTag((tags) => {
      console.log('tags:', tags);
      this.activeTags = tags;
    });
  },
};
</script>

<style lang="scss" scoped>
.tags-view-container {
  position: absolute;
  top: 0;
  left: 180px;
  z-index: 100;
  height: 40px;
  width: 100%;
  background: #fff;
  // border-bottom: 1px solid #d8dce5;
  // box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  box-shadow: 1px 1px 2px 0px rgba(239, 239, 239, 0.5);
  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 100%;
      line-height: 40px;
      // border: 1px solid #d8dce5;
      color: #495060;
      background: #fff;
      padding: 0 18px;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 0;
      span {
        position: relative;
        top: 3px;
        font-size: 22px;
      }
      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        background-color: #f5f5f5;
        color: #4e4e4e;
        border-color: #f5f5f5;
        // &::before {
        //   content: '';
        //   background: #fff;
        //   display: inline-block;
        //   width: 8px;
        //   height: 8px;
        //   border-radius: 50%;
        //   position: relative;
        //   margin-right: 2px;
        // }
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      position: relative;
      display: inline-flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-right: -2px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      text-align: center;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: 100% 100%;
      line-height: 1;
      &:before {
        transform: scale(0.6);
        display: inline-block;
      }
      &:hover {
        // top: 50%;
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
</style>
